/**
 * Transforms an HTML input name property to a valid HTML id.
 * @param name - An HTML input `name` prop.
 * @returns A valid HTML `id` prop.
 */
export function nameToId(name) {
    return name === null || name === void 0 ? void 0 : name.replace(".", "_");
}
//# sourceMappingURL=nameToId.js.map